import angular from 'angular';

import { PREMIUM_FEATURE_NAMES } from '../../constants';

export default function StatusService(
  Authentication,
  Restangular,
  SlingAnalytics,
  $interval,
  $window,
  $document,
  $rootScope,
  $state,
  $timeout
) {
  'ngInject';

  let _lastActiveDate = new Date();

  const service = this;
  service.focus = true;
  service.active = true;
  service.unreadNotifications = 0;
  service.unreadNewsfeedNotifications = 0;
  service.unreadMessages = 0;
  service.orgNotifications = {};

  // PRIVATE

  function _update(objectOrArray) {
    let data = objectOrArray;
    if (angular.isArray(data)) {
      data = data[0];
    }

    service.unreadNotifications = data.unreadNotifications;
    service.unreadNewsfeedNotifications = data.unreadNewsfeedNotifications;
    service.unreadMessages = Authentication.isOrgFeatureEnabled(PREMIUM_FEATURE_NAMES.messages)
      ? data.unreadMessages
      : 0;

    if (data.orgNotifications !== null) {
      service.orgNotifications = data.orgNotifications;
    }
  }

  function _sendAck(data) {
    if (service.active) {
      Restangular.one(data.ack)
        .withHttpConfig({ ignoreLoadingBar: true, ignoreGlobalErrorHandler: true })
        .customPUT({});
    }
  }

  // PUBLIC

  service.refresh = function refresh() {
    return Restangular.one('status')
      .withHttpConfig({ ignoreLoadingBar: true, ignoreGlobalErrorHandler: true })
      .get()
      .then((data) => {
        _update(data);
      });
  };

  service.markNewsfeedNotificationsAsSeen = function markNewsfeedNotificationsAsSeen(id) {
    if (service.unreadNewsfeedNotifications) {
      service.unreadNewsfeedNotifications = 0;
      if (id) {
        Restangular.one('channels/notifications', id).customPUT({
          read: true,
        });
      }
    }
  };

  service.handleAck = function handleAck(data) {
    if (data.ack && typeof data.ack === 'string') {
      if (service.active) {
        _sendAck(data);
      } else {
        $timeout(service.handleAck, 8000, false, data);
      }
    }
  };

  // Activity

  function _updateActive(newValue) {
    if (newValue !== service.active) {
      service.active = newValue;

      if (Authentication.user && service.active) {
        const { userOpened } = SlingAnalytics.analyticsEvents;
        SlingAnalytics.track(userOpened);
      }
    }
  }

  $window.addEventListener('blur', () => {
    service.focus = false;
  });

  $window.addEventListener('focus', () => {
    service.focus = true;
    _updateActive(true);
  });

  $document.bind('keypress', () => {
    _lastActiveDate = new Date();
    _updateActive(true);
  });

  $document.bind('mouseover', () => {
    _lastActiveDate = new Date();
    _updateActive(true);
  });

  function _checkLastActive() {
    const diff = (new Date() - _lastActiveDate) / 1000;
    if (service.active && diff > 5 * 60) {
      _updateActive(false);
    }

    $rootScope.$broadcast('status:check');
  }

  $interval(_checkLastActive, 5000);

  // Sockets

  $rootScope.$on('socket:notification:newsfeed', (event, data) => {
    service.handleAck(data);

    if ($state.includes('newsfeed')) {
      service.markNewsfeedNotificationsAsSeen(data.id);
    } else {
      service.unreadNewsfeedNotifications++;
      service.unreadNewsfeedNotifications =
        service.unreadNewsfeedNotifications > 99 ? 99 : service.unreadNewsfeedNotifications;
    }
  });

  $rootScope.$on('socket:notification:new', (event, data) => {
    service.handleAck(data);
    service.unreadNotifications++;
    service.unreadNotifications =
      service.unreadNotifications > 99 ? 99 : service.unreadNotifications;
  });

  $rootScope.$on('socket:status', (event, data) => {
    _update(data);
  });

  $rootScope.$on('socket:message:new', (event, data) => {
    if (data.type === 'message') {
      service.handleAck(data);
    }

    if ($state.includes('messages')) {
      // @INFO react message module will handle this scenario
    } else if (!data.silenced) {
      service.unreadMessages++;
    }
  });

  service.setUnreadMessages = (value) => {
    $rootScope.$evalAsync(() => {
      service.unreadMessages = value;
    });
  };
}
